import { Component, OnInit, ViewChild, } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { StorageService } from '../storage.service';
import { ValidationService } from '../validation.service';
import { Subscription, Subject } from 'rxjs';
import { EventService } from '../event.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatPaginator } from '@angular/material';

@Component({
  selector: 'app-partial-registration-dashboard',
  templateUrl: './partial-registration-dashboard.component.html',
  styleUrls: ['./partial-registration-dashboard.component.scss']
})
export class PartialRegistrationDashboardComponent implements OnInit {

  partialregistrationDisplayedColumns = ['vehicle', 'driver_name_mobile', 'registereddate', 'loadquantity', 'customername_destination', 'material'];
  partialregistrationdetails: MatTableDataSource<any>;
  dedicated_to = '';
  selectedCarrier: any;
  carrierId: Subscription;
  totalShipments = 0;
  driversFilter: any = {};
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(private http: HttpService, private events: EventService, private snackbar: SnackbarService, private valid: ValidationService, private storage: StorageService,) { }

  ngOnInit() {
    this.selectedCarrier = this.storage.getFromCookie('carrier_id');
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.selectedCarrier = data.carrier_id;
        this.getpartialregistration();
      }
    );
    this.getpartialregistration();
  }
  getpartialregistration(filter: any = {}) {
    filter.limit = this.paginator.pageSize || 50;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    filter.carrier = this.selectedCarrier;
    this.http.get('v1/partialRegistration_carrier', filter, 2).subscribe(
      (response: any) => {
        const statusData = [];
        if (response.statusCode == 200) {
          const data = response.data.records;
          this.totalShipments = response.data.count;
          data.forEach((element, index) => {
            const temp: any = {};
            temp.vehicle = element.vehicle;
            temp.driverName = element.driverName;
            temp.mobile = element.mobile;
            let registeredDate = new Date(element.registeredDate +' UTC');
            temp.registeredDate = registeredDate.toString();
            // temp.registeredDate = element.registeredDate;
            temp.load = element.load;
            temp.cust_name = element.cust_name;
            temp.destination = element.destination;
            temp.materials = element.materials.map(item => item.name).join('\n');
            statusData.push(temp);
          });
          this.partialregistrationdetails = new MatTableDataSource(statusData);
        }
        else {
          this.partialregistrationdetails = new MatTableDataSource([]);

        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }
  pageNavigate(event) {
    this.driversFilter.limit = event.pageSize;
    this.driversFilter.skip = event.pageIndex * event.pageSize;
    this.getpartialregistration(this.driversFilter);
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }
}
